exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.json-editor[data-v-03d4ca30] {\n\theight: 100%;\n\tposition: relative;\n}\n.json-editor[data-v-03d4ca30] .CodeMirror {\n\theight: auto;\n\tmin-height: 300px;\n}\n.json-editor[data-v-03d4ca30] .CodeMirror-scroll {\n\tmin-height: 300px;\n}\n.json-editor[data-v-03d4ca30] .cm-s-rubyblue span.cm-string {\n\tcolor: #f08047;\n}\n", ""]);

// exports
